import React from "react";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";
import RedirectLinkComponent from "../Elements/RedirectLinkComponent";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import mathHelper from "../Helpers/mathHelper";

class IobLineItem {
  constructor(item) {
    if (item === undefined) {
      this.IoblineItemId = "";
      this.IobinvoiceId = "";
      this.CurrencyId = "";
      this.CurrencyName = "";
      this.CurrencySymbol = "";
      this.Amount = "";
      this.Amount1 = "";
      this.Amount2 = "";
      this.AmountPaid = "";
      this.AmountDue = "";
      this.Description = "";
      this.TypeCode = "";
      this.Type = "";
      this.InvoiceId = "";
      this.AssignmentId = "";
      this.AssignmentApolloId = "";
      this.AssignmentStatus = "";
      this.AssignmentCountryCode = "";
      this.AssignmentCountryName = "";
      this.EvaluatorCountryCode = "";
      this.EvaluatorCountryName = "";
      this.InvoiceEvaluatorId = "";
      this.ExportPaymentId = "";
      this.CreatedOn = "";
      this.CreatedBy = "";
      this.ModifiedOn = "";
      this.ModifiedBy = "";
      this.ExportId = "";
      this.EvaluatorName = "";
      this.ExportPaymentCurrencyId = "";
      this.ExportPaymentCurrencyCode = "";
      this.ExportPaymentCurrencySymbol = "";
      this.ExportPaymentPaymentMethod = "";
      this.ExportPaymentPaymentMethodName = "";
      this.ExportPaymentStatusCode = "";
      this.ExportPaymentStatusCodeName = "";
      this.ExportPaymentPaymentDate = "";
      this.ExportPaymentReconciliationDate = "";
      this.ExportPaymentTransactionDate = "";
      this.ExportPaymentTransactionFee = "";
      this.ExportPaymentAdministrativeFee = "";
      this.ExportPaymentTransactionMethod = "";
      this.ExportPaymentTransactionReferenceNumber = "";
      this.ExportPaymentFee = "";
      this.ExportPaymentFeeOriginal = "";
      this.ExportPaymentFeeBase = "";
      this.ExportPaymentFeeBaseOriginal = "";
      this.ExportPaymentFeeAdjustment = "";
      this.ExportPaymentMisc = "";
      this.ExportPaymentTravel = "";
      this.ExportPaymentGaming = "";
      this.ExportPaymentReimbursement = "";
      this.ExportPaymentExpense = "";
      this.ExportPaymentTotal = "";
      this.ExportPaymentPaid = "";
      this.ExportPaymentDue = "";
      this.ExportPaymentVat = "";
      this.ExportPaymentEvaluatorContactName = "";
      this.ThirdPartyJobId = "";
      this.TpJobId = "";
      this.TpJobStatus = "";
      this.ThirdPartyLocationCountry = "";
      return;
    }
    this.IoblineItemId = item.ioblineItemId;
    this.IobinvoiceId = item.iobinvoiceId;
    this.CurrencyId = item.currencyId;
    this.CurrencyName = item.currencyName;
    this.CurrencySymbol = item.currencySymbol;
    this.Amount = mathHelper.ConvertToTwoDecimalNumber(item.amount);
    this.Amount1 = mathHelper.ConvertToTwoDecimalNumber(item.amount1);
    this.Amount2 = mathHelper.ConvertToTwoDecimalNumber(item.amount2);
    this.AmountPaid = item.amountPaid === null ? "0.00" : mathHelper.ConvertToTwoDecimalNumber(item.amountPaid);
    this.AmountDue = mathHelper.ConvertToTwoDecimalNumber(item.amountDue);
    this.Description = item.description;
    this.TypeCode = item.typeCode;
    this.Type = item.type;
    this.InvoiceId = item.invoiceId;
    this.AssignmentId = item.assignmentId;
    this.AssignmentApolloId = item.assignmentApolloId;
    this.AssignmentStatus = item.assignmentStatus;
    this.AssignmentCountryCode = item.assignmentCountryCode;
    this.AssignmentCountryName = item.assignmentCountryName;
    this.EvaluatorCountryCode = item.evaluatorCountryCode;
    this.EvaluatorCountryName = item.evaluatorCountryName;
    this.InvoiceEvaluatorId = item.invoiceEvaluatorId;
    this.ExportPaymentId = item.exportPaymentId;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.CreatedByName = item.createdByName;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
    this.ModifiedByName = item.modifiedByName;
    this.ExportId = item.exportId;
    this.EvaluatorName = item.evaluatorName;
    this.ExportPaymentCurrencyId = item.exportPayment.currencyId;
    this.ExportPaymentCurrencyCode = item.exportPayment.currencyCode;
    this.ExportPaymentCurrencySymbol = item.exportPayment.currencySymbol;
    this.ExportPaymentPaymentMethod = item.exportPayment.paymentMethod;
    this.ExportPaymentPaymentMethodName = item.exportPayment.paymentMethodName;
    this.ExportPaymentStatusCode = item.exportPayment.statusCode;
    this.ExportPaymentStatusCodeName = item.exportPayment.statusCodeName;
    this.ExportPaymentPaymentDate = item.exportPayment.paymentDate;
    this.ExportPaymentReconciliationDate = item.exportPayment.reconciliationDate;
    this.ExportPaymentTransactionDate = item.exportPayment.transactionDate;
    this.ExportPaymentTransactionFee = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.transactionFee);
    this.ExportPaymentAdministrativeFee = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.administrativeFee);
    this.ExportPaymentTransactionMethod = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.transactionMethod);
    this.ExportPaymentTransactionReferenceNumber = item.exportPayment.transactionReferenceNumber;
    this.ExportPaymentFee = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.fee);
    this.ExportPaymentFeeOriginal = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.feeOriginal);
    this.ExportPaymentFeeBase = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.feeBase);
    this.ExportPaymentFeeBaseOriginal = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.feeBaseOriginal);
    this.ExportPaymentFeeAdjustment = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.feeAdjustment);
    this.ExportPaymentMisc = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.misc);
    this.ExportPaymentTravel = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.travel);
    this.ExportPaymentGaming = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.gaming);
    this.ExportPaymentReimbursement = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.reimbursement);
    this.ExportPaymentExpense = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.expense);
    this.ExportPaymentTotal = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.total);
    this.ExportPaymentPaid = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.paid);
    this.ExportPaymentDue = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.due);
    this.ExportPaymentVat = mathHelper.ConvertToTwoDecimalNumber(item.exportPayment.vat);
    this.ExportPaymentEvaluatorContactName = item.exportPayment.evaluatorContactName;
    this.ThirdPartyJobId = item.thirdPartyJobId;
    this.TpJobId = item.tpJobId;
    this.TpJobStatus = item.tpJobStatus;
    this.ThirdPartyLocationCountry = item.thirdPartyLocationCountry;
  }

  static NameOfTheIdField() {
    return "IobinvoiceId";
  }

  static editGeneralFunction = (id, user, userList) => {
    alert("Empty function");
  };

  static nameOfTheItemDetailList() {
    return "IOB";
  }

  static Currency() {
    return "CurrencyName";
  }

  static CurrencySecondary() {
    return "";
  }

  static MoneyFields = ["Amount", "AmountPaid", "Amount1", "Amount2"];
  static MoneyFieldsSecondary = [];
  static DateFields = [];
  static BoolFields = [];
  static FieldsToShowInListTable = [];

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        path="assignments"
        tooltipText={item.AssignmentApolloId}
        text={item.AssignmentApolloId}
        isFigmaStyle={true}
        keyValuePairs={[
          { key: "AsBillClient", value: "" },
          { key: "AsPayEvaluator", value: "" },
          { key: "AsSassieAsgnId", value: item.AssignmentApolloId },
        ]}
      />
    );
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: "fa-solid fa-edit",
            text: "Edit",
            roleKey: "iob_editfinalizemarkaspaidlineitemedit",
            disabled: IobLineItem.getIobStatus() !== "Draft",
            onClick: () => IobLineItem.editGeneralFunction(item.IobinvoiceId, item),
          },
        ]}
      />
    );
  }

  static editGeneralFunction = (id, user, userList) => {
    alert("Empty function");
  };

  static getIobStatus = () => {
    alert("Empty function");
  };

  static FieldsToShowInDataTable() {
    return [
      { label: "Apollo Assignment ID", orderById: "AssignmentApolloId", data: "AssignmentApolloId" },
      { label: "Type", orderById: "Type", data: "Type" },
      { label: "Status", orderById: "AssignmentStatus", data: "AssignmentStatus" },
      { label: "Assignment Country", orderById: "AssignmentCountryName", data: "AssignmentCountryName" },
      { label: "Evaluator Country", orderById: "EvaluatorCountryName", data: "EvaluatorCountryName" },
      { label: "Amount", orderById: "Amount", data: "Amount" },
      { label: " ", orderById: "", data: IobLineItem.getActionsContent, type: FieldTypesEnum.ActionButton, className: "text-center" },
    ];
  }
}

export default IobLineItem;
